import React, { Component } from 'react';
import Onboarding from '../../util/Onboarding';

const showOnboarding = (onboarding, className) => {
  if ((className?.indexOf?.('hide') ?? -1) !== -1) {
    return false; // button is hidden
  }
  return (
    (onboarding === 'edit' && Onboarding.showEditLayerOnboarding()) ||
    (onboarding === 'disable' && Onboarding.showDisableLayerOnboarding()) ||
    (onboarding === 'drilldown' && Onboarding.showDrilldownOnboarding())
  );
};

class OnboardingButton extends Component {
  componentDidMount() {
    const { onboarding, className } = this.props;
    if (!showOnboarding(onboarding, className)) {
      return;
    }
    switch (onboarding) {
      case 'disable': {
        $(this._el).popover({
          title: 'You&#8216;ve added a new step!',
          content:
            "Steps are a <b>fundamental</b> concept in Trevor.  Steps make up your query. <br/><br/>Hover over the steps to see what you can do with them. <button id='got-it' class='btn btn-primary'>Got it</button>",
          html: true,
          trigger: 'manual',
          placement: 'bottom',
          animation: false,
        });
        break;
      }
      case 'drilldown': {
        $(this._el).popover({
          title: 'Explore connected data',
          content:
            "Click the chevron icons to drill-down and explore data related to each row. <button id='got-it' class='btn btn-primary'>Got it</button>",
          html: true,
          trigger: 'manual',
          placement: 'right',
          animation: false,
        });
        break;
      }
    }
    setTimeout(
      () => {
        if (showOnboarding(onboarding, className)) {
          const el = $(this._el);
          el.popover('show');
          $('#got-it').on('click', () => {
            el.popover('hide');
            Onboarding.buttonClicked(onboarding);
          });
        }
      },
      onboarding === 'drilldown' ? 0 : 3000,
    );
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (
      nextProps.onboarding !== this.props.onboarding &&
      !nextProps.onboarding
    ) {
      $(this._el).popover('hide');
    }
  }

  render() {
    const { className, onClick, onboarding, children } = this.props;
    const click = (e) => {
      if (showOnboarding(onboarding, className)) {
        $(this._el).popover('hide');
        Onboarding.buttonClicked(onboarding);
      }
      if (onClick) {
        onClick(e);
      }
    };
    return (
      <span className={className} ref={(sp) => (this._el = sp)} onClick={click}>
        {children}
      </span>
    );
  }
}

export default OnboardingButton;
